import { render, staticRenderFns } from "./patch.bak.vue?vue&type=template&id=5b0a090b&scoped=true"
import script from "./patch.bak.vue?vue&type=script&lang=js"
export * from "./patch.bak.vue?vue&type=script&lang=js"
import style0 from "./patch.bak.vue?vue&type=style&index=0&id=5b0a090b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0a090b",
  null
  
)

export default component.exports